import { Component, computed, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarItem } from '@app/app/shared/models/sidebar/sidebar.model';
import { StyleguideModule } from '@app/app/shared/styleguide/styleguide.module';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'ptl-sidebar-expandable-children',
  standalone: true,
  imports: [RouterModule, StyleguideModule, TranslocoModule],
  templateUrl: './sidebar-expandable-children.component.html',
  styleUrls: ['./sidebar-expandable-children.component.scss'],
})
export class SidebarExpandableChildrenComponent {
  children = input<SidebarItem[]>([]);
  pageSize = input(10);

  displayCount = signal(10);

  displayedChildren = computed(() => this.children().slice(0, this.displayCount()));
  hasMore = computed(() => this.displayCount() < this.children().length);
  remainingCount = computed(() => this.children().length - this.displayCount());

  childClick = output<{ item: SidebarItem; event: Event }>();

  onShowMore(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.displayCount.update((count) => count + this.pageSize());
  }

  onChildClick(event: Event, item: SidebarItem): void {
    this.childClick.emit({ item, event });
  }
}
